import React from "react";

export function useWithErrorHandler(errorHandler: (error: unknown) => void) {
  const [count, setCount] = React.useState(0);

  const withErrorHandler = function <T extends unknown[]>(
    task: (...args: T) => void
  ) {
    return async (...args: T) => {
      try {
        setCount((count) => count + 1);
        await Promise.resolve(task(...args));
      } catch (error) {
        if (error != null) {
          await Promise.resolve(errorHandler(error));
        }
      } finally {
        setCount((count) => count - 1);
      }
    };
  };

  return {
    withErrorHandler,
    busy: !!count,
  };
}
